import {DomainAncestor, entityConfig} from "../../../core/common/domain/DomainAncestor";
import {observable} from "mobx";
import {ID} from "../../../core/metamodel/metaConstant";

@entityConfig()
export class ProjectVersionCapacity extends DomainAncestor {

  @observable capacityId: number;
  @observable area : number;
  @observable countOfHousingUnits: number;
  @observable countOfPeople: number;

  constructor(json: any) {
    super(json);
  }

  public getId(): ID {
    return this.capacityId;
  }

  public setId(id: ID): void {
    this.capacityId = <number>id;
  }
}




// WEBPACK FOOTER //
// ./src/sbtool/domain/project/projectVersionCapacitiesDomain.ts